import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'concat'})
export class ConcatPipe implements PipeTransform {
  transform(value: string, prefixValue: string, suffixValue = ''): string {
    return value ? prefixValue + value + suffixValue : '';
  }
}
